module.exports = __webpack_public_path__ + "static/img/BRAD_HADDIN.d46833b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BRAD_HADDIN.jpg
// module id = FGBr
// module chunks = 0